import {createApiPath, createFetchAndCall} from '../fetch/fetchServices';
import {createEstablishmentObjectForApi} from '../../components/establishment/establishmentModel';
import * as apiConstants from '../../constants/apiConstants';
import mode from '../mode';

class Establishment {

  static createEstablishment(establishment) {
    let createEstablishmentApiPath =
      createApiPath(apiConstants.establishmentApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(createEstablishmentObjectForApi(establishment))
    };
    return createFetchAndCall(createEstablishmentApiPath, options);
  }

  static editEstablishment(establishment, establishmentId) {
    let createEstablishmentApiPath =
      createApiPath(apiConstants.establishmentApi, establishmentId);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(createEstablishmentObjectForApi(establishment))
    };
    return createFetchAndCall(createEstablishmentApiPath, options);
  }

  static removeEstablishment(establishmentId, removalReason) {
    let reason = removalReason || 1;
    let removeEstablishmentApiPath =
      createApiPath(apiConstants.establishmentApi, establishmentId);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify({
        id: establishmentId,
        removal_reason: reason
      })
    };
    return createFetchAndCall(removeEstablishmentApiPath, options);
  }

  static bulkRemoveEstablishment(idArray, userEmail) {
    let removeBulkEstablishmentsApiPath = createApiPath(apiConstants.establishmentBulkRemovalApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify({
        ids: idArray,
        email: userEmail
      })
    };
    return createFetchAndCall(removeBulkEstablishmentsApiPath, options);
  }

  static restoreEstablishment(establishment, establishmentId){
    let restoredEstablishment = Object.assign({}, establishment, {
        establishment_status: 1,
        removal_reason: 0
      });
    let createEstablishmentApiPath =
      createApiPath(apiConstants.establishmentApi, establishmentId);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(restoredEstablishment)
    };
    return createFetchAndCall(createEstablishmentApiPath, options);
  }

  static submitEstablishments(establishments) {
    let submissionsApiPath =
      createApiPath(apiConstants.submissionApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(establishments)
    };
    return createFetchAndCall(submissionsApiPath, options);
  }

  static submitEstablishmentsCombined(establishments) {
    let submissionsApiPath =
      createApiPath(apiConstants.combinedSubmissionApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(establishments)
    };
    return createFetchAndCall(submissionsApiPath, options);
  }

  static queryEstablishmentsWithValidation(data) {
    let queryApiPath = createApiPath(apiConstants.queryEstablishmentsApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    return createFetchAndCall(queryApiPath, options);
  }

  static transferEstablishments(data) {
    let transferApiPath = createApiPath(apiConstants.transferEstablishmentsApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(data)
    };
    return createFetchAndCall(transferApiPath, options);
  }

   static getSubmissionData(link) {
     link = createSubmissionApi(link);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(link, options);
  }

  static getAllEstablishments() {
    let establishmentApiPath =
      createApiPath(apiConstants.establishmentApi);
    let headers = {
      'accept': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(establishmentApiPath, options);
  }

  static getStatePlanStates() {
    let statePlanApi = createApiPath(apiConstants.statePlanApi);
    let headers = {
      'accept': 'application/json',
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(statePlanApi, options);
  }

}

function createSubmissionApi(link, formId) {
  if(formId) {
    link = `${link}/${formId}`;
  }
  if (!mode.prod) {
    link = `${apiConstants.localURL}${link}`;
  }
  return link;
}

export default Establishment;



/** WEBPACK FOOTER **
 ** ./src/api/establishment/EstablishmentApi.js
 **/